import {
  ExportAbsenceAuditLogs,
  ExportAbsenceAuditLogsError,
  ExportAbsenceAuditLogsSuccess,
  GetAbsenceAuditLogs,
  GetAbsenceAuditLogsError,
  GetAbsenceAuditLogsSuccess,
  GetNotificationAuditLogs,
  GetNotificationAuditLogsError,
  GetNotificationAuditLogsSuccess,
  ExportNotificationAuditLogs,
  ExportNotificationAuditLogsError,
  ExportNotificationAuditLogsSuccess,
  GetAbsenceAccessAuditLogs,
  GetAbsenceAccessAuditLogsSuccess,
  GetAbsenceAccessAuditLogsError,
  ExportAbsenceAccessAuditLogs,
  ExportAbsenceAccessAuditLogsSuccess,
  ExportAbsenceAccessAuditLogsError,
  GetAuditLogsReset,
} from "@modules/service/constants/actions";
import * as auditLogsReducers from "./reducers";
import initialState from "./state";
import type { AuditLogsState } from "./types";
import { cloneObject } from "@utils/object";

export default (state: AuditLogsState = initialState, action: Object): AuditLogsState => {
  const act = {
    [GetAbsenceAuditLogs]: auditLogsReducers.setLoading,
    [GetAbsenceAuditLogsSuccess]: auditLogsReducers.onGetAbsenceAuditLogsListSuccess,
    [GetAbsenceAuditLogsError]: auditLogsReducers.setLoaded,
    [ExportAbsenceAuditLogs]: auditLogsReducers.setLoading,
    [ExportAbsenceAuditLogsSuccess]: auditLogsReducers.setLoaded,
    [ExportAbsenceAuditLogsError]: auditLogsReducers.setLoaded,
    [GetNotificationAuditLogs]: auditLogsReducers.onGetNotificationAuditLogs,
    [GetNotificationAuditLogsSuccess]: auditLogsReducers.onGetNotificationAuditLogsSuccess,
    [GetNotificationAuditLogsError]: auditLogsReducers.setLoaded,
    [ExportNotificationAuditLogs]: auditLogsReducers.setLoading,
    [ExportNotificationAuditLogsSuccess]: auditLogsReducers.setLoaded,
    [ExportNotificationAuditLogsError]: auditLogsReducers.setLoaded,
    [GetAbsenceAccessAuditLogs]: auditLogsReducers.setLoading,
    [GetAbsenceAccessAuditLogsSuccess]: auditLogsReducers.onGetAbsenceAccessAuditLogsListSuccess,
    [GetAbsenceAccessAuditLogsError]: auditLogsReducers.setLoaded,
    [ExportAbsenceAccessAuditLogs]: auditLogsReducers.setLoading,
    [ExportAbsenceAccessAuditLogsSuccess]: auditLogsReducers.setLoaded,
    [ExportAbsenceAccessAuditLogsError]: auditLogsReducers.setLoaded,
    [GetAuditLogsReset]: auditLogsReducers.onGetAuditLogsReset,
  };
  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
